import { SxProps, Theme } from '@mui/material';

/** Column layout for the Test Booster pages: gapped full-width sections, padded at the bottom. */
export const boosterPageSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-3xl'],
  width: '100%',
  pb: backrs.spacing['spacing-6xl'],
});

/**
 * Chrome shared by the wizard's post-report steps, so the two halves of one form stay identical
 * as it is tweaked. Step-specific styling stays with its step.
 */

export const stepContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
});

export const stepDividerSx: SxProps<Theme> = ({ backrs }) => ({
  borderColor: backrs.colors['Colors/Border/border-secondary'],
});

export const stepNotSavedSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-warning-primary'],
});

export const stepFieldColumnSx: SxProps<Theme> = ({ backrs }) => ({
  maxWidth: backrs.width['width-sm'],
});

export const stepTitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
});

export const stepIntroBodySx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  marginTop: backrs.spacing['spacing-xs'],
});

export const stepMutedSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

export const stepErrorSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-error-primary'],
});

export const stepChipRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: backrs.spacing['spacing-sm'],
});
